const LABELS = {
  not_contacted: "Sin contactar",
  awaiting: "Esperando respuesta",
  replied: "Respondió",
  interested: "Interesado",
  not_interested: "No interesado",
};
const TONES = {
  not_contacted: "text-zinc-500 border-zinc-700",
  awaiting: "text-zinc-400 border-zinc-600",
  replied: "text-blue-400 border-blue-500/40",
  interested: "text-emerald-400 border-emerald-500/40",
  not_interested: "text-red-400 border-red-500/30",
};

export default function ResponseBadge({ status }) {
  return (
    <span
      className={`text-[10px] px-1.5 py-0.5 rounded-full border font-mono tracking-[0.1em] uppercase ${TONES[status] || TONES.not_contacted}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
